'use client'

import styled, { css } from 'styled-components'

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6
export interface HeadingProps {
  $level?: HeadingLevel
}
export const Heading = styled.h1<HeadingProps>`
  ${({
    theme: {
      typography: { heading },
    },
    $level = 1,
  }) => css`
    ${heading[`heading${$level}` as keyof typeof heading]}
    margin: 0;
  `}
`

export type BodyLevel = 'L' | 'M' | 'S' | 'subtitle' | 'XS'
export interface BodyProps {
  $level?: BodyLevel
  $centered?: boolean
}
export const Body = styled.p<{
  $level?: BodyLevel
  $centered?: boolean
}>`
  ${({
    theme: {
      typography: { body },
    },
    $level = 'M',
    $centered = false,
  }) => css`
    ${body[$level]}
    white-space: pre-line;

    ${$centered &&
    css`
      text-align: center;
    `}
    ul, ol {
      margin-left: 40px;
      margin-bottom: 10px;
    }

    ul {
      list-style: outside disc;
    }

    ol {
      list-style: decimal;
    }

    li {
      padding-left: 10px;
    }
  `}
`

export type LabelLevel = 'XL' | 'L' | 'M' | 'S' | 'XS'
export interface LabelProps {
  $level?: LabelLevel
}
export const Label = styled.div<LabelProps>`
  ${({
    theme: {
      typography: { label },
    },
    $level = 'M',
  }) => css`
    ${label[$level]}
  `}
`
